import { Grid, TablePagination, Typography } from "@mui/material";
import { dateTimeFormat } from "../../../util/DateUtil";
import { currencyRound } from "../../../util/DoubleUtil";
import TablePaginationActions from "../../../shared/components/Table/Actions";

const CantinaCreditoPageView = ({ pageCantinaCredito, handleChangePage }) => {
    return (
        <Grid container spacing={3}>
            <Grid size={12}>
                <Typography variant='h6'>Crédito</Typography>
            </Grid>
            {pageCantinaCredito.content.map((cantinaCredito) =>
                <Grid key={cantinaCredito.codigo} size={12}>
                    <p>Data Hora Crédito: {dateTimeFormat(cantinaCredito.dataHoraCredito)}</p>
                    <p>Valor Crédito: {currencyRound(cantinaCredito.valorCredito)}</p>
                </Grid>)
            }
            <Grid size={12}>
                <TablePagination
                    rowsPerPageOptions={[]}
                    rowsPerPage={pageCantinaCredito.size ? pageCantinaCredito.size : 0}
                    component="div"
                    count={pageCantinaCredito.totalElements}
                    page={pageCantinaCredito.number}
                    onPageChange={handleChangePage}
                    labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : + " mais de " + to))}
                    ActionsComponent={TablePaginationActions}
                />
            </Grid>
        </Grid>
    );
}

export default CantinaCreditoPageView;